import { render, staticRenderFns } from "./ResultFormBoxList.vue?vue&type=template&id=b3d72abe&scoped=true&"
import script from "./ResultFormBoxList.vue?vue&type=script&lang=js&"
export * from "./ResultFormBoxList.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormBoxList.vue?vue&type=style&index=0&id=b3d72abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d72abe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3d72abe')) {
      api.createRecord('b3d72abe', component.options)
    } else {
      api.reload('b3d72abe', component.options)
    }
    module.hot.accept("./ResultFormBoxList.vue?vue&type=template&id=b3d72abe&scoped=true&", function () {
      api.rerender('b3d72abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ResultFormBoxList.vue"
export default component.exports